import { cloneElement, FC, isValidElement, ReactElement, ReactNode, useMemo } from "react";

import { useFormChild } from "@/v1/hooks/useFormChild";
import { RegisterPropsTypes } from "@/v2/context/FormContext/types";

export const FormChild: FC<{ children: ReactNode; type?: RegisterPropsTypes }> = ({
  children,
  type,
}) => {
  const child = children as ReactElement;
  const { onChange, value, errorMessage, required, hasError, forceUpdateValue } = useFormChild({
    childProps: child.props,
    type,
  });

  const actualValue = type ? { defaultChecked: value } : { defaultValue: value };
  const { errors: _e, ...childProps } = child.props;
  const forwardProp = (key: string, propValue?: any) => (propValue ? { [key]: propValue } : {});

  return useMemo(
    () =>
      isValidElement(child)
        ? cloneElement(child, {
            ...childProps,
            ...actualValue,
            ...forwardProp("error", hasError),
            ...forwardProp("errorMessage", errorMessage),
            key: `${childProps.name}-${forceUpdateValue}`,
            onChange,
            required,
          })
        : child,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [forceUpdateValue, errorMessage, child],
  );
};
